import React from 'react'
import IcoButtonStatus from '../../../../../../UI/form/icoButtons/IcoButtonStatus'
import SentimentSatisfiedAltIcon from '@mui/icons-material/SentimentSatisfiedAlt';

const ReceivedItemIco = ({ supplyOrderItem, setOpen }) => {
  return (
    <IcoButtonStatus
        // classNameMain={}
        ico={
            <span>
                <SentimentSatisfiedAltIcon />
                {
                    supplyOrderItem.countReceived ? 
                        <span>
                            {supplyOrderItem.countReceived}
                        </span>
                    : ''
                }
            </span>
        }
        text={'Отримання замовником'}
        textStatus={
            supplyOrderItem.isReceived ? 'Отримано' : 'Не отримано'
        }
        status={
            supplyOrderItem.isReceived ? 'pay' : ''
        }
        onClick={e => {
            if (setOpen) {
                setOpen(true)
            }
        }}
    />
  )
}

export default ReceivedItemIco